<template>
  <div>
    <slot
      v-if="hasHeaderSlot"
      name="header"
    />
    <AppHeader
      v-else
      :actions="['exit', 'menu']"
      :has-shadow="headerHasShadow"
      tall
      :tall-style="headerTallStyle"
      :inverse="inverse"
    />
    <main class="main default-background">
      <slot name="main" />
    </main>
    <slot name="footer" />
    <slot name="modal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '~/components/layout/Header'
export default {
  components: { AppHeader },
  data () {
    return { headerHasShadow: false, headerTallStyle: {} }
  },
  computed: {
    ...mapGetters('server', ['inverse']),

    hasHeaderSlot () {
      return this.$slots['header'] && this.$slots['header'].length !== 0
    },
  },
  mounted () {
    if (typeof window === 'undefined') return

    window.addEventListener('scroll', this.scrolling)
  },
  destroyed () {
    if (typeof window === 'undefined') return

    window.removeEventListener('scroll', this.scrolling)
  },
  methods: {
    getScroll () {
      if (window.pageYOffset !== undefined) {
        return [pageXOffset, pageYOffset]
      } else {
        const d = document
        const r = d.documentElement
        const b = d.body
        const sx = r.scrollLeft || b.scrollLeft || 0
        const sy = r.scrollTop || b.scrollTop || 0
        return [sx, sy]
      }
    },
    scrolling () {
      if (typeof window === 'undefined') { return }
      const scroll = this.getScroll()
      this.headerTallStyle = { transform: `translateY(${scroll[1]}px)` }
      if (scroll[1] >= 100) {
        this.headerHasShadow = true
      } else {
        this.headerHasShadow = false
      }
    },
  },
}
</script>

<style scoped>
.main {
  z-index: 50;
  position: relative;
}
</style>
